import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import { endpoints } from "../endpoints";
import * as accountSettingsActions from "../actions/account_settings_actions";
import * as accountSettingsTypes from "../types/account_settings_types";
import { dispatchSnackbarError } from "../../../../utils/toaster";

function* getAccountSettings(action) {
    try {
        const res = yield call(api.get, endpoints.USER_ACCOUNT_SETTINGS, action.payload);
        if (res.status === 200) {
            yield put(accountSettingsActions.getAccountSettingsSuccess(res.data));
        } else {
            dispatchSnackbarError(res.data.message);
            yield put(accountSettingsActions.getAccountSettingsFailure(res.data));
        }
        if (action.cb) action.cb(res.data);
    } catch (e) {
        yield put(accountSettingsActions.getAccountSettingsFailure(e));
    }
}

function* updateAccountSettings(action) {
    try {
        const res = yield call(api.put, endpoints.USER_ACCOUNT_SETTINGS, action.payload);
        if (res.status === 200) {
            yield put(accountSettingsActions.updateAccountSettingsSuccess(res.data));
        } else {
            dispatchSnackbarError(res.data.message);
            yield put(accountSettingsActions.updateAccountSettingsFailure(res.data));
        }
        if (action.cb) action.cb(res.data);
    } catch (e) {
        yield put(accountSettingsActions.updateAccountSettingsFailure(e));
    }
}


function* getAdminAccountSettings(action) {
    try {
        const res = yield call(api.get, endpoints.CRM_ACCOUNT_SETTINGS.replace(':accountId', action.payload.accountId));
        if (res.status === 200) {
            yield put(accountSettingsActions.getAdminAccountSettingsSuccess(res.data));
        } else {
            dispatchSnackbarError(res.data.message);
            yield put(accountSettingsActions.getAdminAccountSettingsFailure(res.data));
        }
        if (action.cb) action.cb(res.data);
    } catch (e) {
        yield put(accountSettingsActions.getAdminAccountSettingsFailure(e));
    }
}

function* updateAdminAccountSettings(action) {
    try {
        const res = yield call(api.patch, endpoints.CRM_ACCOUNT_SETTINGS.replace(':accountId', action.payload.accountId), action.payload.data);
        if (res.status === 200) {
            yield put(accountSettingsActions.updateAdminAccountSettingsSuccess(res.data));
        } else {
            dispatchSnackbarError(res.data.message);
            yield put(accountSettingsActions.updateAdminAccountSettingsFailure(res.data));
        }
        if (action.cb) action.cb(res.data);
    } catch (e) {
        yield put(accountSettingsActions.updateAdminAccountSettingsFailure(e));
    }
}

export default function* usersSaga() {
    yield takeLatest(accountSettingsTypes.getAccountSettings.REQUEST, getAccountSettings);
    yield takeLatest(accountSettingsTypes.updateAccountSettings.REQUEST, updateAccountSettings);
    yield takeLatest(accountSettingsTypes.getAdminAccountSettings.REQUEST, getAdminAccountSettings);
    yield takeLatest(accountSettingsTypes.updateAdminAccountSettings.REQUEST, updateAdminAccountSettings);
}
